export const environment = {
  production: false,
  // apiBaseUrl: 'https://underwriterintelligence.dev.falconsystem.com/api/',
  // submissionInsightWebSocketUrl: 'wss://underwriterintelligence.dev.falconsystem.com/api/ws/{userId}/{submissionId}',
  // futBaseAdminopUrl: 'https://futuristic-policy.dev.falconsystem.com/ams-v1/adminop/',
  // futBaseUrl: 'https://futuristic-policy.dev.falconsystem.com/ams-v1/quoteop/',
  // assistantApiBaseUrl: 'https://assistant.dev.falconsystem.com/',

  apiBaseUrl: 'https://underwriterintelligence.dev.falconsystem.com/api/',
  submissionInsightWebSocketUrl: 'wss://underwriterintelligence.dev.falconsystem.com/api/ws/{userId}/{submissionId}',
  futBaseAdminopUrl: 'https://futuristic-policy.dev.falconsystem.com/ams-v1/adminop/',
  futBaseUrl: 'https://futuristic-policy.dev.falconsystem.com/ams-v1/quoteop/',
  assistantApiBaseUrl: 'https://assistant.dev.falconsystem.com/',

  Key: 'uQddB!NL$TmaKkmYRuu_S4RF3dM69ehj',
  Iv: 'RvF2$T5dKGeT_CkC',
  
} as const;

